import React from "react";
import { Switch } from "react-router-dom";
import PrivateRoute from "components/common/PrivateRoute";

import Profile from "components/menu/profile/index";

const ProfileRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={Profile}
            />
        </Switch>
    </div>
);

export default ProfileRouter;
